/**
 * client/src/lib/jargon-pattern.ts
 *
 * The technical-jargon screen for user-facing copy, in a module of its own.
 *
 * WHY IT IS NOT IN `terminology.ts`, where it used to live. This pattern has to
 * CONTAIN the tokens it BANS, and one of them is a word the repo's banned-phrase
 * honesty sweep greps for. While the pattern sat inside `terminology.ts`, that
 * whole module — which owns the stamp level words, the tier tooltips, the
 * connection-standing labels and `DEVICE_TENURE_AT_SEND_LABEL` — could only be
 * swept behind a bespoke single-LINE exclusion keyed to the regex literal's
 * exact on-disk formatting. A Prettier re-wrap or a comment inserted above the
 * literal would have silently changed what that exclusion captured.
 *
 * Splitting the pattern out replaces that with the coarse, already-proven
 * mechanism the sweep has always had for this exact situation: a file whose job
 * is to name banned tokens is skipped BY FILENAME, exactly as the sweep skips
 * its own `banned-liveness-strings.ts` fixture. `terminology.ts` is now swept
 * whole, with no exclusion of any kind, and this file is the only thing carved
 * out — a few lines that render nothing.
 *
 * This is a MOVE, not a change: the pattern is byte-identical to the one that
 * lived in `terminology.ts`, and `safePlainLabel` still applies it identically.
 *
 * NOT AN HONESTY GATE. This screens TECHNICAL JARGON so acronyms never reach
 * primary UI copy. It does not reject the presence vocabulary ("present", "in
 * person", "live", "real person") — the banned-phrase sweep and each surface's
 * own rendered-text tests cover that, and no caller may treat a pass here as
 * evidence of anything else.
 */

/** Technical tokens that must never reach primary UI copy (mirrors the
 *  jargon-guard test's banned pattern). */
export const JARGON_PATTERN =
  /\bAAL[0-9]?\b|WebAuthn|FIDO|OSINT|quorum|liveness|acoustic|ML-?DSA|ECDSA|PQC|SHAKE|NIST|FIPS|mnemonic|forensic|attestation|PRF\b|\bseed/i;
